import React from "react";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

export interface IStylingLockComponentState {}

export interface IStylingLockComponentProps {
  defaultLocked?: boolean;
  locked?: boolean;
  onLockChange?: (locked: boolean) => void;
  className?: string;
  disabled?: boolean;
}

export class StylingLockComponent extends React.PureComponent<IStylingLockComponentProps, IStylingLockComponentState> {
  handleChange = () => {
    const value: boolean = this.props.locked
      ? this.props.locked === true
      : this.props.defaultLocked
        ? this.props.defaultLocked === true
        : false;
    if (this.props.onLockChange) {
      this.props.onLockChange(!value);
    }
  };

  render() {
    const isLocked = this.props.locked
      ? this.props.locked === true
      : this.props.defaultLocked
        ? this.props.defaultLocked === true
        : false;

    return (
      <div
        className={this.props.className}
        onClick={this.props.disabled ? undefined : this.handleChange}
        data-locked={isLocked.toString()}
        style={{
          opacity: this.props.disabled ? 0.5 : 1,
          cursor: this.props.disabled ? "not-allowed" : "pointer"
        }}
      >
        {isLocked === true && <KuikaSvg name="lock" width={16} height={16} />}
        {isLocked === false && <KuikaSvg name="lock-open" width={16} height={16} />}
      </div>
    );
  }
}
